export default {
  gptw: {
    description: '¿Quieres medir y certificar tu empresa como un Gran Lugar para trabajar?',
    button: 'Conocer más',
    defaultUrl: 'https://greatplacetowork.com.ec/',
  },
}
